import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import { Avatar, Box, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { EmptyState } from "../common/EmptyState";
import { EntityListCard } from "../common/EntityListCard";
import { SeeAllButton } from "../utils/CardActions";
export const LeaguesCard = ({ leagues, isOwnProfile, }) => {
    const maxToShow = 5;
    const showViewAllLink = leagues.length > maxToShow;
    return (_jsx(EntityListCard, { heading: "Leagues", headerAction: showViewAllLink && _jsx(SeeAllButton, { to: "/leagues" }), items: leagues.slice(0, maxToShow), renderRow: (league, index) => (_jsx(Link, { to: `/leagues/${league.id}/`, style: {
                textDecoration: "none",
                color: "inherit",
                width: "100%",
            }, children: _jsxs(Box, { sx: {
                    bgcolor: index % 2 === 0 ? "transparent" : "#f5f5f5",
                    marginX: -2,
                    paddingY: 1.5,
                    paddingX: 2,
                    width: "calc(100% + 32px)",
                    display: "flex",
                    alignItems: "center",
                }, children: [_jsx(Avatar, { alt: league.name, src: league.logo || undefined, sx: { width: 32, height: 32 }, children: _jsx(EmojiEventsIcon, { fontSize: "small" }) }), _jsx(Typography, { variant: "body1", sx: { marginLeft: 2 }, children: league.name })] }) }, league.id)), emptyState: _jsx(EmptyState, { icon: _jsx(EmojiEventsIcon, {}), heading: "No leagues yet", description: isOwnProfile ? "Create a league to get started." : undefined, actionLabel: isOwnProfile ? "Create League" : undefined, actionTo: isOwnProfile ? "/leagues/create/" : undefined }) }));
};
